import axios from "axios";
import { getConfig } from "../helpers/config";

export class PlessoService {

  baseAPIUrl = `${getConfig()?.url}plessi`;

  findByCodice = async (codice) => {
    return await axios.get(`${this.baseAPIUrl}/codice/${codice}`)
											.then((res) => res.data);
  };

  getAllByComuneId = async (comuneId) => {
    return await axios.get(`${this.baseAPIUrl}/comune/${comuneId}`).then((res) => res.data);
  }

  getAllByBandoIdAndComuneId = async (bandoId, comuneId) => {
    return await axios.get(`${this.baseAPIUrl}/bando/${bandoId}/comune/${comuneId}`).then((res) => res.data);
  }

  findById = async (id) => {
    return await axios.get(`${this.baseAPIUrl}/${id}`).then(resp => resp.data);
  }
}
